export default __webpack_public_path__ + "static/media/icon-flecha.9d75c2f2.svg";